import extracteurDeParametres from "./extracteurDeParametresUrl";

export const UTM_SOURCE_QUERY_PARAM_NOM = 'utm_source';
export const UTM_MEDIUM_QUERY_PARAM_NOM = 'utm_medium';
export const UTM_CAMPAIN_QUERY_PARAM_NOM = 'utm_campain';
export const UTM_TERM_QUERY_PARAM_NOM = 'utm_term';
export const UTM_CONTENT_PARAM_NOM = 'utm_content';
export const UTM_ADGROUP_PARAM_NOM = 'utm_adgroup';
export const LOCALISATION_PARAM_NOM = 'localisation';
export const AGENT_ID_PARAM_NOM = 'AgentID';
export const CTA_SOURCE_PARAM_NOM = 'cta-source';
export const AGENT_APPEL_ENTRANT_LEADS_PARAM_NOM = 'agent_appel_entrant_leads';
export const GCLID_PARAM_NOM = 'gclid'
export const V_SOURCE_NOM = 'v-source';

const parametresAExtraire = [
  UTM_SOURCE_QUERY_PARAM_NOM,
  UTM_MEDIUM_QUERY_PARAM_NOM,
  UTM_CAMPAIN_QUERY_PARAM_NOM,
  UTM_TERM_QUERY_PARAM_NOM,
  UTM_CONTENT_PARAM_NOM,
  UTM_ADGROUP_PARAM_NOM,
  LOCALISATION_PARAM_NOM,
  AGENT_ID_PARAM_NOM,
  CTA_SOURCE_PARAM_NOM,
  AGENT_APPEL_ENTRANT_LEADS_PARAM_NOM,
  GCLID_PARAM_NOM,
  V_SOURCE_NOM
]

export default function(query) {
  return extracteurDeParametres(query, parametresAExtraire);
}
